import { Button, Form, Icon, Input, notification } from 'antd'
import { FormProps } from 'antd/lib/form'
import { Dispatch } from 'easy-peasy'
import React from 'react'
import { connect } from 'react-redux'
import { RouteChildrenProps, withRouter } from 'react-router'
import { AppRoutes, getRoute } from '../AppRoutes'
import { graphTranslations } from '../Diagrams/graphTranslations'
import { IApplicationModel } from '../store/store'
import polyglot from '../Translator'
import { getValidatedFormValues } from '../Utils/FormUtils'
import { LoginLink } from './Login'

const LoginInfosForm = (props: Props) => {
  const { getFieldDecorator } = props.form
  const goToSignUp = () => props.history.push(getRoute(AppRoutes.SIGNUP), props.location.state)
  async function onClickLogin(e) {
    try {
      e.preventDefault()
      const values = await getValidatedFormValues(props.form)
      await props.login(values)
    } catch (error) {
      console.error(error)
      notification.error({
        message: "Erreur d'authentification",
        description: 'Veuillez vérifier que vous avez entré le bon courriel et mot de passse.'
      })
    }
  }

  return (
    <Form
      onSubmit={() => getValidatedFormValues(props.form)}
      style={{ width: '300px', marginTop: '100px', textAlign: 'center' }}
    >
      <h2>{polyglot.tr(graphTranslations.logIn)}</h2>
      <Form.Item>
        {getFieldDecorator('email', {
          rules: [
            {
              required: true,
              message: polyglot.t('provideEmail')
            }
          ]
        })(
          <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={polyglot.t('email')} />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('password', {
          rules: [
            {
              required: true,
              message: polyglot.t('providePassword')
            }
          ]
        })(
          <Input
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder={polyglot.t('password')}
          />
        )}
      </Form.Item>
      <Form.Item>
        <Button type="primary" style={{ width: '100%' }} htmlType="submit" onClick={onClickLogin}>
          {polyglot.tr(graphTranslations.enter)}
        </Button>
        <br />
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <LoginLink onClick={goToSignUp}>{polyglot.t('firstUse')}</LoginLink>
          <LoginLink onClick={props.onForgot}>{polyglot.t('forgotPassword')}</LoginLink>
        </div>
      </Form.Item>
    </Form>
  )
}

interface DispatchProps {
  login: (user) => void
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationModel>): DispatchProps => ({
  login: user => dispatch.user.logIn(user)
})

interface Props extends DispatchProps, RouteChildrenProps, FormProps {
  onForgot: () => void
}

export default connect(
  null,
  mapDispatchToProps
)(Form.create({ name: 'login_form' })(withRouter(LoginInfosForm)))
